import { createFileRoute, redirect } from '@tanstack/react-router';
import { ApplicationSubmittedPage } from '@/features/cleaner/application-submitted/application-submitted';

export const Route = createFileRoute('/(cleaner)/application-submitted')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/cleaner/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: ApplicationSubmittedPage,
});
